import { FC, lazy, Suspense } from "react";
import { HeaderLoader } from "../../components/HeaderLoading";

const OAuthAuthorize = lazy(
  () => import(/* webpackChunkName: "OAuthAuthorize" */ "./OAuthAuthorize"),
);

export const OAuthAuthorizeRoute: FC = function () {
  return (
    <Suspense fallback={<HeaderLoader />}>
      <OAuthAuthorize />
    </Suspense>
  );
};
